import { GroopitFilterDisplayDTO } from "groopit-js/client";
import React from "react";
import { FilterSummaryGenerator } from "./FilterSummaryGenerator";

/// <summary>
/// Displays a "text only" summary of the filter.
/// </summary>
/// <remarks>
/// It's a component because it's actually rich text so it uses spans (and bolding in particular).
/// See the FilterDescription component for a more complex and interactable version.
/// </remarks>
export const FilterSummary = (props: { filter: GroopitFilterDisplayDTO }) => {
  const { filter } = props;
  const summaryText = FilterSummaryGenerator(filter);

  return <span>Summarizing {summaryText}</span>;
};
